import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"บัญชีรายเดือน — ปิดงบ VAT WHT SSO ครบชุดที่เดียว","metaTitle":"รับทำบัญชีรายเดือน SME ไทย — VAT WHT SSO ครบชุด | NYC","metaDesc":"รับทำบัญชีบริษัท SME รายเดือน — บันทึกบัญชี, ยื่น ภพ.30, ภ.ง.ด.1/3/53, สปส. 1-10 พร้อมปิดงบและตรวจสอบ /เดือน — ปรึกษาฟรีก่อนยื่นจริง ลดโอกาสเอกสารตีกลับ"},"en":{"h1":"Monthly Bookkeeping Thailand — VAT, WHT, SSO Full Compliance","metaTitle":"Thailand Monthly Bookkeeping SME — VAT WHT SSO | NYC","metaDesc":"Monthly bookkeeping for Thai SMEs — PP.30 VAT, PND.1/3/53 withholding, SPS.1-10 social security, plus year — Send your documents for a free eligibility check."}} as const;

export const Route = createFileRoute("/accounting/monthly-bookkeeping")({
  head: () => {
    const url = `${SEO_SITE}/accounting/monthly-bookkeeping`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/accounting/monthly-bookkeeping", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/accounting/monthly-bookkeeping", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/accounting/monthly-bookkeeping", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/accounting/monthly-bookkeeping", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/accounting/monthly-bookkeeping", "/en/accounting/monthly-bookkeeping")],
    };
  },
  component: () => <SubServicePage slug="accounting/monthly-bookkeeping" locale="th" />,
});
